import React from 'react';
import { connect } from 'react-redux';
import findIndex from 'lodash/findIndex';
import { RouteComponentProps } from 'react-router-dom';

import * as Types from 'types';
import { Modal } from 'components/modal';
import { getPlaylistParamsFromUrl } from 'player/services/getPlaylistParamsFromUrl';
import { updatePlaylistUrl } from 'player/services/updatePlaylistUrl';

import { PlaylistPlayer } from 'artworkPlayer/components/PlaylistPlayer';

import { withPlayerDispatcher, withPlayerDispatcherProps } from 'player/withPlayerDispatcher';

type StateProps = {
  playlist?: Types.Playlist;
  index: number;
};

type HOCProps = withPlayerDispatcherProps & RouteComponentProps;

type Props = StateProps & HOCProps;

class ModalPlaylistPlayer extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.onArtworkChangedWithinPlayer = this.onArtworkChangedWithinPlayer.bind(this);
  }

  onArtworkChangedWithinPlayer(index: number) {
    const { playlist } = this.props;
    if (!playlist) {
      return;
    }
    const { playlistId } = getPlaylistParamsFromUrl();

    updatePlaylistUrl(this.props.history, playlistId, playlist.items[index].id, true);
  }

  render() {
    const { playlist, index } = this.props;

    if (!playlist) {
      return null;
    }

    return (
      <Modal isOpen={Boolean(playlist)} onRequestClose={this.props.stop} large dark>
        <PlaylistPlayer
          playlist={playlist}
          index={index}
          // @TODO Set autoplay option to false in Safari browser
          options={{ autoplay: true, single: false }}
          onIndexChanged={this.onArtworkChangedWithinPlayer}
        />
      </Modal>
    );
  }
}

const mapStateToProps = ({ player, playlists }: Types.RootState) => {
  const { playlistId, playlistItemId } = player;
  let index = 0;
  let playlist: undefined | Types.Playlist;

  if (playlistId) {
    playlist = playlists.byId[playlistId];
    if (!playlist) {
      console.log(`Playlist ${playlistId} not found in state`);
    }

    if (playlist && playlistItemId) {
      index = findIndex(playlist.items, (playlistItem) => playlistItem.id === playlistItemId);
      if (index < 0) {
        console.log(`Playlist item ${playlistItemId} not found in playlist ${playlist.id}`);
        index = 0;
      }
    }
  }

  return {
    index,
    playlist,
  };
};

export const ModalPlaylistPlayerContainer = connect(mapStateToProps)(
  withPlayerDispatcher(ModalPlaylistPlayer),
);
